import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.071 8.812a6.1 6.1 0 1 1-10.3-5.27v4.35a4.265 4.265 0 0 0 8.43.92Zm-1.95-1.63h1.87A6.11 6.11 0 0 0 5.531 2.5v2.1a4.23 4.23 0 0 1 2.43-.77 4.276 4.276 0 0 1 4.16 3.352Zm-4.16 3.35A2.43 2.43 0 1 0 5.531 8.1a2.433 2.433 0 0 0 2.43 2.432Z';
const draw24px =
  'M22.092,13.338a10.152,10.152,0,1,1-17.13-8.78v7.25a7.1,7.1,0,0,0,14.03,1.53Zm-3.24-2.71h3.11a10.151,10.151,0,0,0-14.08-7.79v3.49a7.086,7.086,0,0,1,10.97,4.3Zm-6.93,5.57a4.045,4.045,0,1,0-4.04-4.05A4.044,4.044,0,0,0,11.922,16.2Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoBuildingConnectedIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'logoBuildingConnected')) as IconWithRender;

LogoBuildingConnectedIcon.displayName = 'LogoBuildingConnectedIcon';
LogoBuildingConnectedIcon.propTypes = Icon.propTypes;
LogoBuildingConnectedIcon.renderIcon = (props) => (
  <LogoBuildingConnectedIcon {...props} />
);
export default LogoBuildingConnectedIcon;
